<template>
<div style="position:relative; margin-top:5px">
    <label class="container-radio" :title="curentJacket+' front'">
    <input type="radio" checked="checked" name="radio" @change="showJacket('front')">
    <span class="checkmark"></span>
    </label>
    <label class="container-radio" :title="curentJacket+' right'">
    <input type="radio" name="radio" @change="showJacket('right')">
    <span class="checkmark"></span>
    </label>
    <label class="container-radio" :title="curentJacket+' back'">
    <input type="radio" name="radio" @change="showJacket('back')">
    <span class="checkmark"></span>
    </label>
    <label class="container-radio" :title="curentJacket+' left'">
    <input type="radio" name="radio" @change="showJacket('left')">
    <span class="checkmark"></span>
    </label>
</div>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
    name: 'Switches',
    created() {
      this.$store.watch( getters => getters.curentJacket),
      this.$store.watch( getters => getters.jacketSelectd)
      this.$store.watch( getters => getters.styles)
      this.$store.watch( getters => getters.sizes)
    },
    computed: {
      ...mapGetters({
        jacketSelectd: 'jacketSelectd',
        curentJacket: 'curentJacket',
        styles: 'styles',
        sides: 'sides'
      })
    },
    methods:{
      showJacket(type){
        let jacket = this.curentJacket
        let jacketStyle = this.styles
        let sides = this.sides
        let payload = { style: jacket, jacketType: jacketStyle, set: type, sides: sides}
        this.$store.dispatch('set_'+type, payload)
      }
    },
}
</script>

<style scoped>
/* The container-radio */
.container-radio {
  display: inline-block;
  position: relative;
  padding-left: 30px;
  padding-right: 10px;
  cursor: pointer;
  font-size: 22px;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}

/* Hide the browser's default radio button */
.container-radio input {
  position: absolute;
  opacity: 0;
  cursor: pointer;
}

/* Create a custom radio button */
.checkmark {
  position: absolute;
  top: 0;
  left: 0;
  height: 25px;
  width: 25px;
  background-color: #b3b3b3;
  border-radius: 50%;
}

/* On mouse-over, add a grey background color */
.container-radio:hover input ~ .checkmark {
  background-color: #9a9a9a;
}

/* When the radio button is checked, add a blue background */
.container-radio input:checked ~ .checkmark {
  background-color: #b82a2f;
}

/* Create the indicator (the dot/circle - hidden when not checked) */
.checkmark:after {
  content: "";
  position: absolute;
  display: inline-block;
}

/* Show the indicator (dot/circle) when checked */
.container-radio input:checked ~ .checkmark:after {
  display: inline-block;
}
</style>